<template>
  <b-container>
    <!-- Optional Slot to Add Content Rows Above the Locator -->
    <b-row>
      <b-col>
        <slot name="header"></slot>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <div v-if="userStore">
          <!-- @TODO - Replace Button Row with a Slot but use existing markup as 'fallback/default' value -->
          <SingleStoreInfo
            :store="userHasStoreSelected"
            @clearStore="resetStore"
          >
            <template v-slot:buttons>
              <div class="btn-actions">
                <div class="btn-custom mw-200 active" @click.stop="resetStore">
                  <i aria-hidden="true" class="fa fa-angle-left"></i>
                  Change Store
                </div>
                <!-- @TODO - Create Button Components for Easier Restyling -->
                <div
                  @click.stop="goToNext"
                  class="btn-custom mw-200 bk-blue store-details-btn"
                >
                  <span class="store-detail-link">Select Services</span>
                  <i aria-hidden="true" class="fa fa-angle-right"></i>
                </div>
              </div>
            </template>
          </SingleStoreInfo>
        </div>
        <div v-else>
          <StoreNav :search_results="storeResults" :locationSearchView="true">
            <template v-slot:single_result="data">
              <SingleStoreResultCompactVariant
                :store="data.item"
                :isMyStore="data.isMyStore"
                :locationSearchView="true"
                :item_index="data.item_index"
              >
              </SingleStoreResultCompactVariant>
            </template>
          </StoreNav>
        </div>
      </b-col>
    </b-row>
    <!-- Optional Slot to Add Content Rows Below the Locator -->
    <b-row>
      <b-col>
        <slot name="footer"></slot>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import SingleStoreInfo from "@/components/partials/SingleStoreInfo.vue";
import SingleStoreResultCompactVariant from "@/components/store-locator/SingleStoreResultCompactVariant.vue";
import StoreNav from "../StoreNav";
export default {
  name: "StoreLocator",
  components: {
    StoreNav,
    SingleStoreInfo,
    SingleStoreResultCompactVariant,
  },
  created() {
    //this.searchStores();
    this.$store.dispatch("autoLocateUser");
  },
  computed: {
    userHasStore() {
      return this.$store.getters.userHasStore;
    },
    complete() {
      return this.$store.getters.formStore;
    },
    userStore() {
      return this.$store.state.user.selectedStoreForInquiry;
    },
    userMyStore() {
      return this.$store.state.myStore;
    },
    userHasStoreSelected() {
      // @TODO - Logic flow doesn't really allow this to work, as it's pulling whatever values are good...
      if (this.userStore !== null) {
        return this.userStore;
      }
      if (this.userMyStore !== null) {
        return this.userMyStore;
      }
      return false;
    },
    storeResults() {
      return this.$store.state.user.search_results;
    },
    user() {
      return this.$store.state.user;
    },
  },
  methods: {
    resetStore() {
      this.$store.commit("resetFormStore");
    },
    goToNext() {
      if (this.userHasStore) {
        this.$emit("next");
      }
    },
    setStore(store) {
      console.log(store);
      //this.$store.commit("setStore", cur_place);
      //this.$store.commit("setFormLocation", cur_place)
    },
    searchStores(city) {
      const vm = this;
      this.$store
        .dispatch("getGeoResults", {
          search: { ["location-search"]: city.city + ", " + city.region },
        })
        .then(function () {
          console.log(vm);
        });
    },
  },
};
</script>
<style>
.store-container .map-area {
  min-width: 300px;
  max-width: 100%;
}
.store-container .location-area {
  min-width: 300px;
  max-width: 100%;
  border: 2px solid #999;
}
.store-container .close-btn {
  display: none;
}
#store-selection-nav
  .store-container
  .location-area
  .geolocate-area
  .btn-location {
  width: auto;
}
#store-selection-nav .vue-map-container {
  height: 700px !important;
}
#store-selection-nav .store-container .location-area .scroll-area {
  height: calc(700px - 73px);
}
.tw-location-container {
  margin-bottom: 1rem;
}
@media (max-width: 850px) {
  .store-container > .map-area {
    display: none;
  }
}
</style>
